let selectedData = null;
let originalDeviceData = null;

function formatDeviceData({ label, serial, c_sep = ":::" }) {
  return `${label}${c_sep}${serial}`;
}

// Format phone for display: +818012345678 → 08012345678
function formatPhoneForDisplay(phone) {
  if (!phone) return '';
  const cleaned = phone.trim();
  if (cleaned.startsWith('+81')) {
    return '0' + cleaned.substring(3);
  }
  return cleaned;
}

// Track active modal element to support duplicate modals per view
window.__activeModalEl = window.__activeModalEl || null;

// Snackbar utility for modal flows
function ecocoShowSnackbar(message, duration = 1800) {
  let sb = document.querySelector(".ecoco-snackbar");
  if (!sb) {
    sb = document.createElement("div");
    sb.className = "ecoco-snackbar";
    Object.assign(sb.style, {
      position: "fixed",
      left: "50%",
      bottom: "20px",
      transform: "translateX(-50%)",
      background: "#2b2f33",
      color: "#fff",
      padding: "10px 16px",
      borderRadius: "6px",
      zIndex: "9999",
      opacity: "0",
      transition: "opacity .15s ease",
    });
    document.body.appendChild(sb);
  }
  sb.textContent = message || "";
  sb.style.opacity = "1";
  clearTimeout(window.__ecocoSbTimer);
  window.__ecocoSbTimer = setTimeout(() => {
    sb.style.opacity = "0";
  }, duration);
}

function openModal(type, data = null) {
  if (data instanceof HTMLElement) {
    selectedData = data.getAttribute("data-order");
  } else if (typeof data === "string") {
    selectedData = data;
  } else if (typeof data === "object" && data !== null) {
    selectedData = data || null;
  }
  // Prefer a modal within the same visible view as the trigger element
  let scopeRoot = document;
  if (data instanceof HTMLElement) {
    scopeRoot =
      data.closest("#account-esim-view") ||
      data.closest("#account-ecoco-view") ||
      document;
  }
  const modal =
    scopeRoot.querySelector("#customModal") ||
    document.getElementById("customModal");
  const modalContent = modal
    ? modal.querySelector("#modalDynamicContent")
    : document.getElementById("modalDynamicContent");
  let template =
    scopeRoot.querySelector(`#modal-${type}`) ||
    document.getElementById(`modal-${type}`);
  if (template) {
    modalContent.innerHTML = "";
    modalContent.appendChild(template.content.cloneNode(true));
    modal.style.display = "block";
    window.__activeModalEl = modal;
    // Rakuten modal configuration: hide email, validate ID, auto-dash, enable on valid, snackbar on submit
    if (type === "rakuten-register") {
      const scope = window.__activeModalEl || document;
      const content = scope.querySelector('.modal-content');
      const orderInput = content ? content.querySelector('#rakuten-order-id') : null;
      const emailInput = content ? content.querySelector('#rakuten-email') : null;
      let submitBtn = content ? content.querySelector('#rakutenSubmitBtn') : null;

      // Hide email row and add future note
      if (emailInput) {
        const emailRow = emailInput.closest('.modal-row');
        if (emailRow) emailRow.style.display = 'none';
        // Dev note: Email may be required in the future. Keep UI hidden for now.
      }

      // Add/locate inline error under the Rakuten ID input
      let errorEl = content ? content.querySelector('#rakutenOrderError') : null;
      let hintEl = content ? content.querySelector('#rakutenOrderHint') : null;
      if (orderInput) {
        const parent = orderInput.parentElement || orderInput.closest('.modal-input') || orderInput;
        if (!errorEl) {
          errorEl = document.createElement('div');
          errorEl.id = 'rakutenOrderError';
          errorEl.style.color = '#e53935';
          errorEl.style.fontSize = '12px';
          errorEl.style.marginTop = '6px';
          parent.appendChild(errorEl);
        }
        if (!hintEl) {
          hintEl = document.createElement('div');
          hintEl.id = 'rakutenOrderHint';
          hintEl.style.color = '#777';
          hintEl.style.fontSize = '10px';
          hintEl.style.marginTop = '4px';
            hintEl.textContent = 'ハイフンは自動で入力されます。';
          parent.appendChild(hintEl);
        }
      }

      // Validation: typical Rakuten format 3-7-7 digits (e.g., 123-4567890-1234567)
      const isValidOrder = (v) => /^\d{3}-\d{7}-\d{7}$/.test((v || '').trim());
      const autoFormat = (raw) => {
        const digits = String(raw || '').replace(/\D/g, '');
        if (!digits) return '';
        if (digits.length <= 3) return digits;
        if (digits.length <= 10) return `${digits.slice(0,3)}-${digits.slice(3)}`;
        return `${digits.slice(0,3)}-${digits.slice(3,10)}-${digits.slice(10,17)}`;
      };
      let touched = false;
      const updateState = () => {
        const val = orderInput ? orderInput.value : '';
        const ok = isValidOrder(val);
        if (submitBtn) submitBtn.disabled = !ok;
        if (errorEl) {
          if (touched) {
            errorEl.textContent = ok ? '' : '必須項目です。形式はXXX-XXXXXXX-XXXXXXXで入力してください。';
          } else {
            errorEl.textContent = '';
          }
        }
        return ok;
      };

      if (orderInput) {
        orderInput.setAttribute('inputmode', 'numeric');
        orderInput.setAttribute('pattern', '^\\d{3}-\\d{7}-\\d{7}$');
        orderInput.addEventListener('input', () => {
          const formatted = autoFormat(orderInput.value);
          if (orderInput.value !== formatted) {
            orderInput.value = formatted;
          }
          if (!touched && orderInput.value.length > 0) touched = true;
          updateState();
        });
        orderInput.addEventListener('blur', () => {
          touched = true;
          updateState();
        });
      }
      if (submitBtn) submitBtn.disabled = true;
      updateState();

      // Ensure old handlers are cleared by replacing the button node
      if (submitBtn && submitBtn.parentNode) {
        const newBtn = submitBtn.cloneNode(true);
        newBtn.disabled = submitBtn.disabled;
        submitBtn.parentNode.replaceChild(newBtn, submitBtn);
        submitBtn = newBtn;
      }
      if (submitBtn) {
        submitBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (!updateState()) return;
            ecocoShowSnackbar('楽天IDが送信されました');
          closeModal();
        });
      }
      // Service-backed submission (overrides prior simple handler)
      if (submitBtn && submitBtn.parentNode) {
        const newBtn2 = submitBtn.cloneNode(true);
        newBtn2.disabled = submitBtn.disabled;
        submitBtn.parentNode.replaceChild(newBtn2, submitBtn);
        submitBtn = newBtn2;
        submitBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          if (!updateState()) return;
          const orderId = orderInput ? (orderInput.value || '').trim() : '';
          const email = emailInput ? (emailInput.value || '').trim() : '';
          const customerId = document.getElementById('ecoco-customerId')?.getAttribute('data-value') || '';
          const prevText = submitBtn.textContent;
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting…';
          try {
            if (window.esimService && typeof window.esimService.registerRakuten === 'function') {
              await window.esimService.registerRakuten({ orderId, email, customerId });
            } else {
              await new Promise((r) => setTimeout(r, 500));
            }
            ecocoShowSnackbar('Rakuten ID registered');
            closeModal();
          } catch (err) {
            console.warn('registerRakuten failed', err);
            const msg = '登録に失敗しました。時間をおいて再度お試しください。';
            const errEl = (window.__activeModalEl || document).querySelector('#rakutenOrderError');
            if (errEl) errEl.textContent = msg; else alert(msg);
          } finally {
            submitBtn.textContent = prevText;
            submitBtn.disabled = false;
          }
        });
      }
      return modalContent;
    }
    if (type === "edit-phone") {
      const scope = window.__activeModalEl || document;
      const phoneInput = scope.querySelector("#quickPhoneInput");
      const errorEl = scope.querySelector("#quickPhoneError");
      const saveBtn = scope.querySelector("#quickPhoneSaveBtn");

      const triggerEl = data instanceof HTMLElement ? data : null;
      const addressId = triggerEl?.getAttribute("data-address-id") || "";
      const initialPhone = triggerEl?.getAttribute("data-phone") || "";

      if (phoneInput) phoneInput.value = formatPhoneForDisplay(initialPhone);

      const getConfigValue = (id) => {
        const el = document.getElementById(id);
        return el ? (el.dataset.value || "").trim() : "";
      };

      const customerId = getConfigValue("ecoco-customerId");
      const customerIdHash = getConfigValue("ecoco-customerIdHash");
      const baseUrl = getConfigValue("ecoco-update-address-baseUrl");
      const endpoint = getConfigValue("ecoco-update-address-endpoint");

      const showErr = (msg) => {
        if (!errorEl) return;
        errorEl.textContent = msg || "";
        errorEl.style.display = msg ? "block" : "none";
      };

      const normalizePhoneForSave = (value) => {
        const raw = String(value || "").trim();
        if (!raw) {
          return { ok: false, error: "電話番号を入力してください。" };
        }

        try {
          // If starts with +, parse as international
          if (raw.startsWith('+')) {
            const phoneNumber = window.libphonenumber.parsePhoneNumber(raw);
            if (phoneNumber && phoneNumber.isValid()) {
              return { ok: true, phone: phoneNumber.format('E.164') };
            }
          }
          
          // No + prefix = assume Japan
          const phoneNumber = window.libphonenumber.parsePhoneNumber(raw, 'JP');
          if (!phoneNumber || !phoneNumber.isValid()) {
            return { ok: false, error: "有効な電話番号を入力してください。" };
          }
          return { ok: true, phone: phoneNumber.format('E.164') };
        } catch (err) {
          return { ok: false, error: "有効な電話番号を入力してください（例: 08012345678、海外の場合は +14155552671）。" };
        }
      };

      if (!saveBtn || !phoneInput) return modalContent;

      saveBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        showErr("");

        const normalized = normalizePhoneForSave(phoneInput.value);
        if (!normalized.ok) {
          showErr(normalized.error);
          return;
        }
        const canonicalPhone = normalized.phone;
        phoneInput.value = canonicalPhone;
        if (!addressId) {
          showErr("デフォルト住所が見つかりません。");
          return;
        }
        if (!customerId || !customerIdHash) {
          showErr("認証情報が不足しています。再ログインしてください。");
          return;
        }
        if (!baseUrl || !endpoint) {
          showErr("API設定が見つかりません。");
          return;
        }

        const prevText = saveBtn.textContent;
        saveBtn.disabled = true;
        saveBtn.textContent = "保存中...";
        try {
          const response = await fetch(`${baseUrl}/${endpoint}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              customerId,
              customerIdHash,
              addressId,
              address: { phone: canonicalPhone },
            }),
          });

          let body = {};
          try {
            body = await response.json();
          } catch (_) {
            body = {};
          }

          if (!response.ok || body.ok === false) {
            const details = body.details ? ` (${JSON.stringify(body.details)})` : "";
            throw new Error((body.error || `HTTP ${response.status}`) + details);
          }

          const persistedPhone = body?.customer_address?.phone || canonicalPhone;
          if (triggerEl) {
            triggerEl.setAttribute("data-phone", persistedPhone);
            const valueEl = triggerEl.closest(".phone-edit-inline")?.querySelector(".default-phone-value");
            if (valueEl) valueEl.textContent = formatPhoneForDisplay(persistedPhone);
          }
          closeModal();
          ecocoShowSnackbar("電話番号を更新しました");
        } catch (err) {
          console.error("Quick phone update failed:", err);
          showErr(err?.message || "電話番号の更新に失敗しました。");
        } finally {
          saveBtn.disabled = false;
          saveBtn.textContent = prevText;
        }
      });

      return modalContent;
    }
    // Register/Edit device logic
    if (type === "register-device" || type === "edit-device") {
      const isEditMode = type === "edit-device" || (data && data.isEdit);
      const registerBtn = modal.querySelector("#saveBtn");
      const label = modal.querySelector("#labelInput");
      const labelError = modal.querySelector("#labelError");
      const serial = modal.querySelector("#serialInput");
      const serialError = modal.querySelector("#serialError");
      const modalTitle = modal.querySelector(".modal-title");
      if (modalTitle) {
        modalTitle.textContent = isEditMode
          ? "シリアル番号編集"
          : "デバイス登録";
      }
      // Pre-fill values in edit mode
      if (isEditMode && data && typeof data === "object") {
        label.value = data.label || "";
        serial.value = data.serial || "";
        originalDeviceData = { ...data }; // Store original values
      }
      registerBtn.addEventListener("click", function () {
        const labelValue = label.value.trim();
        const serialValue = serial.value.trim();
        const serialPattern = /^\d{13}$/; // Exactly 13 digits, only numbers
        let isValid = true;
        // Clear previous error messages
        labelError.textContent = "";
        serialError.textContent = "";
        labelError.style.display = "none";
        serialError.style.display = "none";
        if (labelValue.length === 0 || labelValue.length > 15) {
          labelError.textContent = "ラベルは15文字以内で入力してください。";
          labelError.style.display = "block";
          isValid = false;
        }
        if (!serialPattern.test(serialValue)) {
          serialError.textContent =
            "シリアル番号は13桁の数字で入力してください。";
          serialError.style.display = "block";
          isValid = false;
        }
        if (isValid) {
          // Proceed with saving the data
          const newDeviceData = {
            label: label.value,
            serial: serial.value,
          };
          if (isEditMode) {
            // If in edit mode, update the existing data
            const originalFormatted = formatDeviceData(originalDeviceData);
            const newFormatted = formatDeviceData(newDeviceData);
            updateDevice(originalFormatted, newFormatted);
          } else {
            let result = "";
            Object.values(newDeviceData).forEach((value) => {
              result += String(value) + ",";
            });
            addDevice(result.trim());
          }
          closeModal();
        }
      });
    } else if (type === "delete-device") {
      // Delete device logic
      const deleteBtn = modal.querySelector("#deleteBtn");
      if (deleteBtn) {
        deleteBtn.addEventListener("click", () => {
          if (!selectedData) {
            console.log("シリアル番号が見つかりませんでした！");
            return;
          }
          deleteDevice(selectedData);
          closeModal();
        });
      }
    } else if (type === "view-pdf") {
      // PDF Logic
      const nameError = modal.querySelector("#nameError");
      const nameInput = modal.querySelector("#name-input");
      const viewBtn = modal.querySelector("#view-pdf-btn");
      let accountData = null;
      let parseError = null;
      if (selectedData) {
        try {
          accountData = JSON.parse(selectedData);
        } catch (err) {
          parseError = err;
        }
      } else {
        parseError = new Error("Missing order payload");
      }
      if (parseError) {
        console.error("PDF payload parse failed:", parseError, selectedData);
        const uiMsg =
          "エラーが発生しました。管理者にご連絡ください。開発者コンソールをご確認ください。";
        if (nameError) {
          nameError.textContent = uiMsg;
          nameError.style.display = "block";
        }
        if (viewBtn) viewBtn.disabled = true;
        ecocoShowSnackbar(uiMsg);
        return modalContent;
      }
      const fullName = `${accountData.billing_address?.last_name ?? ""} ${
        accountData.billing_address?.first_name ?? ""
      }`.trim();

      if (nameInput) {
        nameInput.value = fullName;
      }

      // Validation function for name input
      function validateNameField() {
        const value = nameInput.value.trim();
        if (value.length === 0 || value.length > 30) {
          nameError.textContent = "ご担当者名は30文字以内で入力してください。";
          nameError.style.display = "block";
          viewBtn.disabled = true;
          return false;
        } else {
          nameError.textContent = "";
          nameError.style.display = "none";
          viewBtn.disabled = false;
          return true;
        }
      }

      // Initial check (in case modal auto-fills the input)
      validateNameField();

      // Listen for real-time input changes
      nameInput.addEventListener("input", validateNameField);

      if (viewBtn) {
        viewBtn.addEventListener("click", async () => {
          if (!validateNameField()) return;
          if (!selectedData) {
            console.log("ファイルが見つかりませんでした！", selectedData);
            return;
          }

          const companyInput = modal.querySelector("#company-name-input");
          const fullName =
            `${accountData.billing_address?.last_name ?? ""} ${accountData.billing_address?.first_name ?? ""}`.trim();

          let updatedName = (
            document.getElementById("name-input")?.value || ""
          ).trim();
          if (!updatedName) updatedName = fullName;

          // Split to last/first (simple rule, same as before)
          const parts = updatedName.split(" ");
          let lastName = parts[0] || "";
          let firstName = parts[1] || "";

          // Prepare payload
          const dataObj = JSON.parse(JSON.stringify(accountData || {}));
          if (dataObj.billing_address) {
            dataObj.billing_address.last_name = lastName;
            dataObj.billing_address.first_name = firstName;
            dataObj.billing_address.name = `${lastName} ${firstName}`.trim();
            dataObj.billing_address.company = (
              companyInput?.value || ""
            ).trim();
          }

          // Immediately open a uniquely-named tab (prevents popup blocking, allows multiple)
          const winName = `pdfPreview_${Date.now()}_${Math.random().toString(36).slice(2)}`;
          const previewWin = window.open("", winName);

          // If blocked, previewWin can be null — we’ll still proceed, and fallback later.
          if (previewWin && previewWin.document) {
            // Show a friendly loading page (no “blank” tab)
            previewWin.document.open();
            previewWin.document.write(`
            <!doctype html>
            <html lang="ja">
              <head>
                <meta charset="utf-8" />
                <title>PDF 読み込み中...</title>
                <style>
                  html,body{height:100%;margin:0;}
                  body{display:flex;align-items:center;justify-content:center;font-family:system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,'Noto Sans JP',sans-serif;color:#333}
                  .wrap{text-align:center}
                  .spinner{width:48px;height:48px;border-radius:50%;border:4px solid #ddd;border-top-color:#555;animation:s 1s linear infinite;margin:0 auto 12px;}
                  @keyframes s{to{transform:rotate(360deg)}}
                </style>
              </head>
              <body>
                <div class="wrap">
                  <div class="spinner"></div>
                  <div>PDFを準備しています…</div>
                </div>
              </body>
            </html>
          `);
            previewWin.document.close();
          }

          // Close modal after we’ve pointed the tab to the PDF
          closeModal();

          try {
            // Fetch PDF as Blob
            const pdfBlob = await postPdf(dataObj);

            // Create URL and navigate the pre-opened tab
            const pdfUrl = URL.createObjectURL(pdfBlob);

            if (previewWin && !previewWin.closed) {
              previewWin.location = pdfUrl; // switch from loading page to the PDF
            } else {
              // Fallback if popup was blocked or tab closed
              window.open(pdfUrl, "_blank");
            }

            // Cleanup the object URL later
            setTimeout(() => URL.revokeObjectURL(pdfUrl), 60_000);
          } catch (err) {
            console.error("Error generating or displaying PDF:", err);
            // Show a friendly message in the pre-opened tab if it exists
            if (previewWin && previewWin.document && !previewWin.closed) {
              previewWin.document.open();
              previewWin.document.write(`
              <!doctype html>
              <html lang="ja">
                <head><meta charset="utf-8" /><title>エラー</title></head>
                <body style="font-family:system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,'Noto Sans JP',sans-serif">
                  <p>PDFの生成に失敗しました。ページを閉じて、もう一度お試しください。</p>
                </body>
              </html>
            `);
              previewWin.document.close();
            }
            alert("PDFの生成に失敗しました。時間をおいて再度お試しください。");
          } finally {
            viewBtn.textContent = "発行";
            viewBtn.disabled = false;
          }
        });
      }
    } 
    return modalContent;
  }
}

function closeModal() {
  if (window.__activeModalEl) {
    window.__activeModalEl.style.display = "none";
    return;
  }
  // Fallback: hide any modal(s)
  const modals = document.querySelectorAll("#customModal");
  modals.forEach((m) => (m.style.display = "none"));
}

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    closeModal();
  }
});
